import axios from "axios"
import * as env from "../constants/env"

/* Games */
export const games = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* View */
export const game = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Players */
export const players = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/players`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Player View */
export const view = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/player-view`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Credit */
export const credit = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/credit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Credit All */
export const creditAll = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/credit-all`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* End Game */
export const end = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/end-game`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* CHANGE PAUSE STATUS */
export const togglePause = (data) => {
    const uri = `${env.gamepoint}punto-banco/game/toggle-pause-status`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
